import React from 'react';
import { connect } from 'react-redux';

import MainMenu from '../../components/mainMenu';
import ControlPanel from '../../components/controlPanel';
import FilesTree from '../../components/filesTree';
import FilesBrowser from '../../components/filesBrowser';
import NavigationPanel from '../../components/navigationPanel';
import ServersPanel from '../../components/serversPanel';
import { setFileContent } from '../../actions';
import { selectElements } from '../../actions/selectedElement';

import './main.scss';
import 'antd/dist/antd.css';

const Main = ({ selectedElement, selectedElement: { selectedElements }, setSelectedElements, browserData, siteId }) => {
	return (
		<div className="content-manager">
			<div className="content-manager__main">
        <MainMenu />

				<ControlPanel />

				<div className="content-manager__main__content">
					<div className="content-manager__main__content__left-side">
						<ServersPanel />
						<FilesTree />
					</div>

					<div className="content-manager__main__content__files-browser">
						<NavigationPanel />
						<FilesBrowser
							browserData={browserData}
							siteId={siteId}
							selectedElements={selectedElement.selectedElements}
							setSelectedElements={setSelectedElements}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { files: { browserData }, selectedElement, selectedElement: { siteId, selectedElements, directory } } = state;
	return {
		siteId,
		selectedElement,
		selectedElements,
		directory,
		browserData
	};
};

const mapDispatchToProps = (dispatch) => ({
	fileContent: (data) => dispatch(setFileContent(data)),
	setSelectedElements: (data) => dispatch(selectElements(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
